import { CRMServicePopup } from '../CRM/Orders/Service-popup.js';

export class CRM {

	bookBlock(table, id, parent)
	{
		ajax.post('/ajax.php?mid=47', 
			{
				action: 'bookBlock',
				table: table,
				id: id
			}, 
			{
				dataType: 'json',
				success: (json) => 
				{
					if (json.success)
					{

					}
				}
			}
		);
	}

	doSearch(parent)
	{
		let _this = this;

		clearTimeout(this.delayTimer);
		this.delayTimer = setTimeout(function() {
			_this.loadOrders(parent)
		}, 400);
	}

	loadOrders(parent)
	{
		let formData = new FormData();
		formData.append(parent.name, parent.value);
		formData.append('action', 'loadOrders');
		console.log(formData);
		ajax.post('/ajax.php?mid=47', 
			formData, 
			{
				dataType: 'html',
				success: (html) => 
				{
					$('.orders__table-wrapper').replaceWith(html);
				}
			}
		);
	}

	loadBlock(table, id)
	{
		let crmOrders = new CRMServicePopup(vroc, table, id);
		
	}

	applyFilter(parent)
	{
		let formData = new FormData(parent.form);
		formData.append('action', 'loadXML');
		ajax.post('/ajax.php?mid=3', 
			formData, 
			{
				dataType: 'text',
				success: (text) => 
				{
					window.state.doc = window.state.parser.parseFromString(
						text, 
						"text/xml"
					);
					window.state._triggerUpdate();
				}
			}
		);
	}

	gotoOrder(id)
	{
		location.href = '/crm/?id=' + id;
	}

	applyEvents()
	{
		
	}
}